import { useState, useEffect } from "react"
import { EventHero } from "./event-hero"
import { CountdownTimer } from "./countdown-timer"
import { PricingTable } from "./pricing-table"
import { VenueMap } from "./venue-map"
import { ArtistBio } from "./artist-bio"
import { EventDetails } from "./event-details"

export function EventPage({ rows, setCurrentZone, setModalTitle, setModalShow }) {
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  useEffect(() => {
    const calculateCountdown = () => {
      // 1pm hora México (America/Mexico_City = UTC-6), sin depender de la hora local del usuario
      const dateStr = String(rows.presale_date_event).split("T")[0]
      const baseDate = new Date(`${dateStr}T13:00:00-06:00`)
      const targetDate = baseDate.getTime()
      const now = new Date().getTime()
      const difference = targetDate - now

      if (difference > 0) {
        setTimeRemaining({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        })
      }
    }

    calculateCountdown()
    const interval = setInterval(calculateCountdown, 1000)
    return () => clearInterval(interval)
  }, [rows.presale_date_event])

  return (
    <main className="event-page">
      <EventHero event={rows} />

      {rows.presale_enabled && (
        <section className="section-padding">
          <div className="container">
            <CountdownTimer time={timeRemaining} />
          </div>
        </section>
      )}

      <section style={{ backgroundColor: "rgba(28, 32, 52, 0.5)" }} className="section-padding">
        <div className="container">
          <h2 className="text-center mb-5" style={{ fontSize: "2rem", fontWeight: "bold" }}>
            Plano Referencial
          </h2>
          <VenueMap rows={rows} />
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <h2 className="text-center mb-5" style={{ fontSize: "2rem", fontWeight: "bold" }}>
            Precios por Zona
          </h2>
          <PricingTable rows={rows} setCurrentZone={setCurrentZone} setModalTitle={setModalTitle} setModalShow={setModalShow} />
        </div>
      </section>

      <section
        style={{ background: "linear-gradient(180deg, rgba(180, 83, 9, 0.1) 0%, transparent 100%)" }}
        className="section-padding"
      >
        <div className="container">
          <ArtistBio rows={rows} />
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <EventDetails rows={rows} />
        </div>
      </section>
    </main>
  )
}
